import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { schedulingCalendarAPI } from "../../../api/service";

export interface IRemoveResourceSlice {
  removeResponse: any;
  loading: boolean;
  error: any;
  status: string;
}

const INITIAL_STATE = {
  removeResponse: null,
  loading: false,
  error: null,
  status: "idle",
} as IRemoveResourceSlice;

export const removeResourceSchedule = createAsyncThunk(
  "scheduling/removeResourceSchedule",
  schedulingCalendarAPI.removeResourceSchedule
);

export const RemoveResourceScheduleSlice = createSlice({
  name: "removeResourceSchedule",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(removeResourceSchedule.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(removeResourceSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.removeResponse = action.payload.data;
        state.status = "succeeded";
      })
      .addCase(removeResourceSchedule.rejected, (state, action) => {
        state.loading = false;
        state.removeResponse = null;
        state.error = action.payload;
        state.status = "failed";
      });
  },
});

